<template>
  <component
    :is="baseComponent"
    :to="link.path ? link.path : '/'"
    :class="{ active: isActive }"
    tag="li"
  >
    <a
      v-if="isMenu"
      href="#"
      class="nav-link sidebar-menu-item"
      :aria-expanded="!collapsed"
      data-toggle="collapse"
      @click.prevent="collapseMenu"
    >
      <md-icon v-if="link.icon">{{ link.icon }}</md-icon>
      <md-icon v-if="link.image">
      <md-avatar style="height: auto; width: auto; min-width: auto">
        <img :src="link.image" alt="Avatar">
      </md-avatar>
      </md-icon>
      <p>
        {{ link.name }}
        <b class="caret"></b>
      </p>
    </a>

    <collapse-transition>
      <div v-if="$slots.default || this.isMenu" v-show="!collapsed">
        <ul class="nav">
          <slot></slot>
        </ul>
      </div>
    </collapse-transition>

<!--    <slot-->
<!--      name="title"-->
<!--      v-if="children.length === 0 && !$slots.default && link.path"-->
<!--    >-->
<!--      <component-->
<!--        :to="link.path  + '3'"-->
<!--        @click.native.stop.prevent="linkClick(link.path)"-->

<!--        :is="elementType(link, false)"-->
<!--        :class="{ active: link.active, 'tm-sidebar-red-notification': notification }"-->
<!--        class="nav-link "-->
<!--        :target="link.target + '2'"-->
<!--        :href="link.path + '1'"-->
<!--      >-->
<!--        <template v-if="addLink">-->
<!--          <span class="sidebar-mini">{{ linkPrefix }}</span>-->
<!--          <span class="sidebar-normal">1{{ link.name }}</span>-->
<!--        </template>-->
<!--        <template v-else>-->
<!--          <md-icon>{{ link.icon }}</md-icon>-->
<!--          <p>2{{ link.name }}</p>-->
<!--        </template>-->
<!--      </component>-->
<!--    </slot>-->


    <slot
        name="title"
        v-if="children.length === 0 && !$slots.default && link.path"
    >

      <template>
        <a
            :href="link.path"
            @click.stop.prevent="linkClick(link)"
            :class="{ active: link.active, 'tm-sidebar-red-notification': notification }"
            class="nav-link "
            :target="link.target"
        >
          <template v-if="addLink">
            <span class="sidebar-mini">{{ linkPrefix }}</span>
            <span class="sidebar-normal">{{ link.name }}</span>
          </template>
          <template v-else>
            <md-icon>{{ link.icon }}</md-icon>
            <p>{{ link.name }}</p>
          </template>
        </a>
      </template>
    </slot>
    <ModaWarningCloseOrderForRetoucherDialog
        v-if="showedWarningModal"
        @reload="confirmLinkClick"
        @close="showedWarningModal = false"
        :local_page_keys="local_page_keys"/>
  </component>
 </template>
<script>
import ModaWarningCloseOrderForRetoucherDialog from "@/pages/Dashboard/Components/Dialogs/ModaWarningCloseOrderForRetoucherDialog";
export default {
  name: "sidebar-item",
  components:  {ModaWarningCloseOrderForRetoucherDialog},
  props: {
    menu: {
      type: Boolean,
      default: false
    },
    opened: {
      type: Boolean,
      default: false
    },
    link: {
      type: Object,
      default: () => {
        return {
          name: "",
          icon: "",
          image: "",
          path: "",
          children: []
        };
      }
    },
    notification: {
      type: Boolean,
      default: false
    },
    local_page_keys: {
      type: Object,
      default:null
    },
    role: {
      type: String,
      default:null
    }
  },
  provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild
    };
  },
  inject: {
    addLink: { default: null },
    removeLink: { default: null },
    autoClose: {
      default: true
    }
  },
  data() {
    return {
      children: [],
      collapsed: !this.opened,
      showedWarningModal:false,
      clickedLink:null
    };
  },
  computed: {
    baseComponent() {
      return this.isMenu || this.link.isRoute ? "li" : "router-link";
    },
    linkPrefix() {
      if (this.link.name) {
        let words = this.link.name.split(" ");
        return words.map(word => word.substring(0, 1)).join("");
      }
      return false;
    },
    isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    isActive() {
      if (this.$route && this.$route.path) {
        let matchingRoute = this.children.find(c =>
          this.$route.path.startsWith(c.link.path)
        );
        if (matchingRoute !== undefined) {
          return true;
        }
        if (this.link.path === this.$route.path)
          return true;
      }
      return false;
    }
  },
  methods: {
    addChild(item) {
      const index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild(item) {
      const tabs = this.children;
      const index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType(link, isParent = true) {
      if (link.isRoute === false) {
        return isParent ? "li" : "a";
      } else {
        return "router-link";
      }
    },
    linkAbbreviation(name) {
      const matches = name.match(/\b(\w)/g);
      return matches.join("");
    },
    linkClick(link) {
      if (!this.addLink) {
        this.$sidebar.collapseAllMenus();
      }

      if (
          this.autoClose &&
          this.$sidebar &&
          this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
      this.showModalCloseWarningForRetoucher(link)
    },
    async showModalCloseWarningForRetoucher(link) {
      if (this.$route.path === link.path) {
        return
      }
      if (this.role !== 'retoucher' || this.$route.name !== 'RetouchersOrderFuncBasedNewProstoyWrapper') {
        return this.$router.push(link.path);
      }

      let data = await this.$store.getters['order/downtimeIdleTime'];
      if (data && data.order_in_work) {

        this.clickedLink = link;
        this.showedWarningModal = true
      } else {
        return this.$router.push(link.path);
      }
    },
    collapseMenu() {
      if (this.collapsed) {
        this.$sidebar.addSidebarLink(this);
        this.$sidebar.collapseAllMenus();
      }

      this.collapsed = !this.collapsed;
    },
    collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    },
    async confirmLinkClick() {
      this.showedWarningModal = false;
      if (this.clickedLink) {
        await this.$router.push(this.clickedLink.path);
        this.clickedLink = null;
      }
    }
  },
  mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }
  },
  destroyed() {
    this.$sidebar.removeSidebarLink(this);
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  }
};
</script>
<style></style>
